import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import {
	Collapse,
	IconButton,
	TableCell,
	TableRow,
	Typography,
	useTheme,
} from '@mui/material';
import dayjs from 'dayjs';
import React, { FC, useState } from 'react';
import ReactDiffViewer from 'react-diff-viewer';
import { HistoryInterface } from '../../interfaces';
import { useTranslation } from '../../services';

const HistoryTableRow: FC<{ row: HistoryInterface }> = ({ row }) => {
	const { t } = useTranslation();
	const theme = useTheme();
	const [open, setOpen] = useState(false);

	return (
		<>
			<TableRow key={row.id} sx={{ '& > *': { borderBottom: 'unset !important' } }}>
				<TableCell>
					<IconButton
						aria-label="expand row"
						size="small"
						onClick={() => setOpen(!open)}
					>
						{open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
					</IconButton>
				</TableCell>
				<TableCell>{row.id}</TableCell>
				<TableCell>{row.user_id}</TableCell>
				<TableCell>{row.student_id}</TableCell>
				<TableCell>{row.request_id}</TableCell>
				<TableCell>{row.notes}</TableCell>
				<TableCell>{dayjs(row.dateTime).format('DD.MM.YYYY hh:mm')}</TableCell>
			</TableRow>
			<TableRow>
				<TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
					<Collapse in={open} timeout="auto" unmountOnExit>
						<Typography variant="h6" component="div">
							{t('Changes')}
						</Typography>
						<ReactDiffViewer
							oldValue={JSON.stringify(row.update.from, null, 2)}
							newValue={JSON.stringify(row.update.to, null, 2)}
							splitView={true}
							useDarkTheme={theme.palette.mode === 'dark'}
						/>
					</Collapse>
				</TableCell>
			</TableRow>
		</>
	);
};
export default HistoryTableRow;
